import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as submissionsApi from '../api/submissions';
import * as uploadApi from '../api/upload';

export const useMySubmission = (gameId, roundId) => {
  return useQuery({
    queryKey: ['submission', gameId, roundId],
    queryFn: () => submissionsApi.getMySubmission(gameId, roundId),
    enabled: !!gameId && !!roundId,
  });
};

export const useUpdateSubmission = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => submissionsApi.updateSubmission(gameId, roundId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['submission', gameId, roundId] });
      queryClient.invalidateQueries({ queryKey: ['influence', gameId] });
    },
  });
};

export const useSubmitSubmission = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => submissionsApi.submitSubmission(gameId, roundId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['submission', gameId, roundId] });
      queryClient.invalidateQueries({ queryKey: ['gameState', gameId] });
    },
  });
};

export const useAllSubmissions = (gameId, roundId) => {
  return useQuery({
    queryKey: ['submissions', gameId, roundId],
    queryFn: () => submissionsApi.getAllSubmissions(gameId, roundId),
    enabled: !!gameId && !!roundId,
  });
};

export const useContributionStatus = (gameId, roundId) => {
  return useQuery({
    queryKey: ['contributionStatus', gameId, roundId],
    queryFn: () => submissionsApi.getContributionStatus(gameId, roundId),
    enabled: !!gameId && !!roundId,
    // Real-time updates via WebSocket (useGameSocket hook)
  });
};

export const useUploadMedia = (gameId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ file, type }) => uploadApi.uploadMedia(gameId, file, type),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['submission'] });
    },
  });
};

export const useDeleteMedia = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (mediaId) => uploadApi.deleteMedia(mediaId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['submission'] });
    },
  });
};
